import React from "react"
import { BsFolder2Open } from "react-icons/bs"
import MI_Ext from "./_ext"

class MI_commu extends MI_Ext {
  renderIcon = () => {
    return <BsFolder2Open />
  }
}
export default MI_commu
